export default class PageObject {
    constructor(PageComponent, self, parents, canBeDefault, buildPath = () => undefined) {
        this.clone = () => new PageObject(this.PageComponent, this.self, this.parents, this.canBeDefault, this.buildPath);
        this.PageComponent = PageComponent;
        this.self = self;
        this.parents = parents;
        this.canBeDefault = canBeDefault;
        this.buildPath = buildPath;
    }
}
